import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TresorerieService } from '../../../../../services/tresorerie/tresorerie.service';

@Component({
  selector: 'app-ajout-solde',
  templateUrl: './ajout-solde.component.html',
  styleUrls: ['./ajout-solde.component.scss']
})
export class AjoutSoldeComponent implements OnInit {
  @Output() soldeCreated = new EventEmitter<void>();
  @ViewChild('modalAjoutSolde') modalTemplate!: TemplateRef<any>;

  formData: {
    type_solde_input: string;
    montant_total: string;
  } = {
    type_solde_input: '',
    montant_total: ''
  };

  /** Stations / entrepôts (`currentUser.stations`) */
  stations: any[] = [];
  /** `station_id` envoyé à l’API */
  selectedStationId = 0;

  userId = 0;
  isLoading = false;
  private modalRef!: NgbModalRef;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private tresorerieService: TresorerieService
  ) {}

  ngOnInit(): void {
    this.loadUserData();
  }

  private loadUserData(): void {
    try {
      const userJson = localStorage.getItem('currentUser');
      if (userJson) {
        const user = JSON.parse(userJson);
        this.userId = user?.id || 0;
        this.stations = Array.isArray(user?.stations) ? user.stations : [];
        this.syncDefaultStation();
      }
    } catch {
      this.toastr.error('Erreur lors de la récupération des données utilisateur.', 'Erreur');
    }
  }

  /** Libellé affiché pour une station (entrepôt). */
  stationLabel(st: any): string {
    if (!st) {
      return '';
    }
    return (
      st.label ||
      st.nom ||
      st.name ||
      st.libelle ||
      (st.id != null ? `Entrepôt #${st.id}` : '')
    );
  }

  private syncDefaultStation(): void {
    if (this.selectedStationId && this.stations.some((s) => Number(s?.id) === this.selectedStationId)) {
      return;
    }
    const first = this.stations[0];
    this.selectedStationId = first?.id != null ? Number(first.id) : 0;
  }

  openModal(): void {
    this.loadUserData();
    this.resetForm();
    const options: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      keyboard: true,
      size: 'md'
    };
    this.modalRef = this.modalService.open(this.modalTemplate, options);
  }

  private resetForm(): void {
    this.syncDefaultStation();
    this.formData = {
      type_solde_input: '',
      montant_total: ''
    };
  }

  /** Valeur envoyée à l’API (chaîne, comme en base `solde_tresorerie.type_solde`). */
  private typeSoldeSaisi(): string {
    return this.formData.type_solde_input.trim();
  }

  enregistrer(): void {
    const typeSolde = this.typeSoldeSaisi();
    if (!this.validateForm(typeSolde)) {
      return;
    }
    this.isLoading = true;

    const montant = Number(this.formData.montant_total.toString().replace(',', '.'));
    const payload = {
      station_id: this.selectedStationId,
      type_solde: typeSolde,
      montant_total: montant.toFixed(3),
      user_id: this.userId || undefined
    };
    this.tresorerieService.createSolde(payload).subscribe({
        next: () => {
          this.toastr.success('Caisse ajoutée avec succès.', 'Succès');
          this.modalRef.close();
          this.soldeCreated.emit();
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Erreur création solde:', err);
          const msg =
            err?.error?.message ||
            err?.error?.error ||
            "Impossible de créer la caisse (elle existe peut-être déjà pour cet entrepôt).";
          this.toastr.error(msg, 'Erreur');
          this.isLoading = false;
        }
      });
  }

  private validateForm(typeSolde: string): boolean {
    if (!this.selectedStationId) {
      this.toastr.error('Sélectionnez un entrepôt.', 'Erreur');
      return false;
    }
    if (!typeSolde) {
      this.toastr.error('Indiquez le nom de la caisse (champ obligatoire).', 'Erreur');
      return false;
    }
    const m = parseFloat(this.formData.montant_total.toString().replace(',', '.'));
    if (this.formData.montant_total === '' || this.formData.montant_total === null || isNaN(m) || m < 0) {
      this.toastr.error('Indiquez un montant initial valide (≥ 0).', 'Erreur');
      return false;
    }
    return true;
  }
}
